const routeConfig = {
  BUYER_FINANCING: {
    key: 'BUYER_FINANCING',
    URL: '/invoices/buyer-finance',
  },
  SELLER_FINANCING: {
    key: 'SELLER_FINANCING',
    URL: '/invoices/seller-finance',
  },
}

export default routeConfig
